var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"variant":"secondary","disabled":_vm.formLoading,"pressed":!_vm.file.is_needed,"pill":""},on:{"click":function($event){$event.stopPropagation();return _vm.toggleState.apply(null, arguments)}}},[(_vm.formLoading)?_c('b-spinner',{attrs:{"label":"Setting..."}}):_c('span',[_vm._v(_vm._s(_vm.buttonText))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }